import React from 'react';
import { SvgIcon } from '@mui/material';

export function SberLogo(props) {
  return (
    <SvgIcon
      sx={{ width: '200px', height: '64px', viewBox: '0 0 200px 64px' }}
      {...props}
      viewBox="0 0 200 64"
      fill="none"
    >
      <svg
        width="200"
        height="64"
        viewBox="0 0 200 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M147.361 22.7058L153.491 18.2483H133.432V44.715H153.491V40.2574H139.004V33.5711H151.262V29.1136H139.004V22.7058H147.361Z"
          fill="#21A038"
        />
        <path
          d="M118.109 28.5564H111.144V22.7058H122.288L128.139 18.2483H105.572V44.715H117.552C124.238 44.715 128.139 41.6504 128.139 36.3571C128.139 31.3423 124.517 28.5564 118.109 28.5564ZM117.273 40.2574H111.144V33.0139H116.995C120.616 33.0139 122.288 34.1283 122.288 36.6357C122.567 39.143 120.895 40.2574 117.273 40.2574Z"
          fill="#21A038"
        />
        <path
          d="M169.648 18.2483H158.783V44.715H164.634V37.1928H169.648C176.613 37.1928 180.792 33.5711 180.792 27.7206C180.792 21.87 176.613 18.2483 169.648 18.2483ZM169.37 33.0139H164.355V22.7058H169.37C172.992 22.7058 174.942 24.656 174.942 27.7206C174.942 30.7851 172.992 33.0139 169.37 33.0139Z"
          fill="#21A038"
        />
        <path
          d="M95.8215 39.143C94.4285 39.9788 92.4783 40.536 90.8068 40.536C85.5134 40.536 81.8917 36.9143 81.8917 31.8995C81.8917 26.8848 85.5134 23.263 90.8068 23.263C92.7569 23.263 94.4285 23.8202 96.1001 24.9346L100 21.5914V21.3129C97.4931 19.0841 94.4285 18.2483 90.8068 18.2483C86.9064 18.2483 83.2847 19.6413 80.7773 22.1486C78.2699 24.656 76.5984 28.2778 76.8769 31.8995C76.8769 35.5213 78.2699 39.143 80.7773 41.6504C83.5633 44.1578 87.185 45.5507 90.8068 45.5507C94.9857 45.5507 98.6075 44.1578 100.836 41.6504L97.2145 38.8644L95.8215 39.143Z"
          fill="#21A038"
        />
        <path
          d="M58.4902 18.2483C59.6046 19.6413 60.4404 21.0343 60.9976 22.7058L41.2173 37.1928L32.8594 31.8995V25.7704L41.2173 31.0637L58.4902 18.2483Z"
          fill="#21A038"
        />
        <path
          d="M24.2218 31.4957C24.2218 31.2171 24.2218 30.9385 24.2218 30.6599L19.207 30.3813C19.207 30.6599 19.207 31.2171 19.207 31.4957C19.207 37.6249 21.7144 42.9182 25.6147 47.0971L29.2365 43.4754C26.1719 40.4108 24.2218 36.2319 24.2218 31.4957Z"
          fill="url(#paint0_linear_11733_38777)"
        />
        <path
          d="M41.2186 14.7804C41.4972 14.7804 41.7758 14.7804 42.0544 14.7804L42.333 9.76562C42.0544 9.76562 41.4972 9.76562 41.2186 9.76562C35.0895 9.76562 29.5175 12.273 25.6172 16.1733L29.2389 19.7951C32.3035 16.7305 36.4824 14.7804 41.2186 14.7804Z"
          fill="url(#paint1_linear_11733_38777)"
        />
        <path
          d="M41.2159 48.4908C40.9374 48.4908 40.6588 48.4908 40.3802 48.4908L40.1016 53.5055C40.3802 53.5055 40.9374 53.5055 41.2159 53.5055C47.3451 53.5055 52.917 50.9982 56.8173 47.0978L53.1956 43.4761C50.131 46.5406 45.9521 48.4908 41.2159 48.4908Z"
          fill="url(#paint2_linear_11733_38777)"
        />
        <path
          d="M50.6891 17.6909L54.868 14.6263C51.2463 11.5617 46.5101 9.61157 41.2168 9.61157V14.6263C44.8386 14.6263 47.9031 15.7407 50.6891 17.6909Z"
          fill="url(#paint3_linear_11733_38777)"
        />
        <path
          d="M63.2253 31.6208C63.2253 30.2278 63.2253 29.1134 62.9467 27.7205L58.2106 31.0636C58.2106 31.0636 58.2106 31.3422 58.2106 31.6208C58.2106 36.6355 55.9818 41.0931 52.6387 44.1576L55.9818 48.058C60.4394 43.8791 63.2253 38.0285 63.2253 31.6208Z"
          fill="#21A038"
        />
        <path
          d="M41.2165 48.3363C36.2018 48.3363 31.7442 46.1076 28.6796 42.7644L24.7793 46.3862C28.6796 50.8437 34.5302 53.6297 41.2165 53.6297V48.3363Z"
          fill="url(#paint4_linear_11733_38777)"
        />
        <path
          d="M29.7937 19.0842L26.4505 15.4624C21.993 19.3628 19.207 25.2133 19.207 31.621H24.2218C24.2218 26.6063 26.4505 22.1487 29.7937 19.0842Z"
          fill="url(#paint5_linear_11733_38777)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_11733_38777"
            x1="25.2599"
            y1="46.4753"
            x2="20.0843"
            y2="31.5373"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.1444" stopColor="#F2E913" />
            <stop offset="0.3037" stopColor="#E7E518" />
            <stop offset="0.5823" stopColor="#CADB26" />
            <stop offset="0.891" stopColor="#A3CD39" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_11733_38777"
            x1="27.1906"
            y1="15.6716"
            x2="40.3432"
            y2="10.6677"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0592" stopColor="#0FA8E0" />
            <stop offset="0.5385" stopColor="#0099F9" />
            <stop offset="0.9234" stopColor="#0291EB" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_11733_38777"
            x1="39.7582"
            y1="49.1462"
            x2="55.434"
            y2="45.6105"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.1226" stopColor="#A3CD39" />
            <stop offset="0.2846" stopColor="#86C339" />
            <stop offset="0.8693" stopColor="#21A038" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_11733_38777"
            x1="40.1035"
            y1="12.9826"
            x2="53.1404"
            y2="16.9977"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0566" stopColor="#0291EB" />
            <stop offset="0.79" stopColor="#0C8ACB" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_11733_38777"
            x1="26.2073"
            y1="46.9364"
            x2="40.2059"
            y2="52.1595"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.1324" stopColor="#F2E913" />
            <stop offset="0.2977" stopColor="#EBE716" />
            <stop offset="0.5306" stopColor="#D9E01F" />
            <stop offset="0.8023" stopColor="#BBD62D" />
            <stop offset="0.9829" stopColor="#A3CD39" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_11733_38777"
            x1="23.2375"
            y1="32.2534"
            x2="28.8341"
            y2="17.7145"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0698" stopColor="#A3CD39" />
            <stop offset="0.2599" stopColor="#81C55F" />
            <stop offset="0.9216" stopColor="#0FA8E0" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
}
